import * as React from "react";

export class HeadName extends React.Component<{ label: string }, {}> {
    render() {
        return (
            <span className="rj-racing-table__head-name">
                {this.props.label}
            </span>
        );
    }
}